import * as React from 'react'
import PropTypes from 'prop-types'
import makeStyles from '@material-ui/core/styles/makeStyles'
import Container from 'components/Container'
import Html from 'components/Html'
import Section from 'components/Section'

export const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    ...theme.mixins.contain('var(--coa-content-max-width)'),
    padding: 'var(--coa-section-spacing) var(--coa-container-spacing)',
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.getContrastText(theme.palette.text.primary),
  },
}))

function InfoBox(props) {
  const { content } = props
  const classes = useStyles(props)

  return (
    <Section className={classes.root} gutters="margin">
      <Container maxWidth={false}>
        <Html className={classes.content} dangerouslySetInnerHTML={{ __html: content }} />
      </Container>
    </Section>
  )
}

InfoBox.propTypes = {
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
}

export default InfoBox
